import React from 'react';

export const formatEventDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(`${dateString}T00:00:00`);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const EventCard = ({ event }) => (
  <article className="event-card">
    <div className="event-card__image">
      <img src={event.image} alt={event.title} />
    </div>
    <div className="event-card__body">
      <span className="event-card__date">{formatEventDate(event.date)}</span>
      <h3 className="event-card__title">{event.title}</h3>
      {event.description && (
        <p className="event-card__description">{event.description}</p>
      )}
    </div>
  </article>
);

export default EventCard;
